import { render, staticRenderFns } from "./Duurzaam.vue?vue&type=template&id=1fa967e7&scoped=true&"
import script from "./Duurzaam.vue?vue&type=script&lang=js&"
export * from "./Duurzaam.vue?vue&type=script&lang=js&"
import style0 from "./Duurzaam.vue?vue&type=style&index=0&id=1fa967e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa967e7",
  null
  
)

export default component.exports